import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FleteCargoCompradorComponent } from './flete-cargo-comprador.component';
import { ArrowSvgModule } from 'src/app/shared/styles/svg/arrow/arrow.module';
import { AmountModule } from '../../amount/amount.module';
import { NumberInputModule } from 'src/app/components/inputs/number/number.module';
import { RadioButtonInputModule } from 'src/app/components/inputs/radio-buttons/radio-buttons.module';
import { SelectInputModule } from 'src/app/components/inputs/select/select.module';



@NgModule({
  declarations: [
    FleteCargoCompradorComponent
  ],
  imports: [
    CommonModule,
    ArrowSvgModule,
    AmountModule,
    NumberInputModule,
    RadioButtonInputModule,
    SelectInputModule
  ],exports:[
    FleteCargoCompradorComponent
  ]
})
export class FleteCargoCompradorModule { }
